// Master JS for Passwordless page

import { WireupHandlers, SetTextContent, SetElementsVisible, SetLoadingState } from "./lib/data-wireup.js";
import { PostJSON } from "./lib/fetchers.js";
import { FormToObject } from "./lib/form-utilities.js";
import { WireupRecaptcha, ExecuteRecaptcha } from "./lib/recaptcha.js";

import { SubmitStatus } from "./webcomponents/submit-status.js";

// Register required webcomponents
SubmitStatus.Register();

// Hang onto email for use on page 2
let email;
let isResend = false;

WireupRecaptcha("recaptcha-email", onReCaptchaEmailSubmit, "code-status");

// Email form submit
// Note: we don't set the button loading state here because we have to wait until after recaptcha processes, in case they click out
WireupHandlers("sendemail", "submit", async () => {
    SubmitStatus.Hide("email-status");
    isResend = false;
    ExecuteRecaptcha();
});

// Resend email
WireupHandlers("resend", "click", async () => {
    SubmitStatus.Set("code-status", "Resending code...", false, true);
    isResend = true;
    ExecuteRecaptcha();
});

// Return to previous page
WireupHandlers("page1", "click", async () => {
    SetElementsVisible("entercode", false);
    SetElementsVisible("sendemail", true);
});

/**
 * On recaptcha success, submit the email
 */
async function onReCaptchaEmailSubmit(token) {
    try {
        SetLoadingState("emailsubmit", true);
        SubmitStatus.Hide("code-status");
        const form = document.querySelector("[data-wireup-sendemail]");
        const formData = FormToObject(form);
        email = formData.email;
        await PostJSON("/users/passwordless/email", { email, token });
        // Populate and show page 2
        SetTextContent("email", email);
        SetElementsVisible("sendemail", false);
        SetElementsVisible("entercode", true);
        // Focus to the code input
        const field = document.getElementById("signinCode");
        field.focus();
        if (isResend) {
            SubmitStatus.Set("code-status", "We sent a new code to " + email + ". Please check your email, then return here and enter the code.", false);
        } else {
            SubmitStatus.Set("code-status", "We sent a code to " + email + ". Please check your email, then return here and enter the code.", false);
        }
    } catch (err) {
        console.error(err);
        SubmitStatus.Set("email-status", err.message, true);
    } finally {
        SetLoadingState("emailsubmit", false);
    }
}

// Code form submit
WireupHandlers("entercode", "submit", async () => {
    SubmitStatus.Hide("code-status");

    try {
        const form = document.querySelector("[data-wireup-entercode]");
        const formData = FormToObject(form);
        const returnUrl = new URLSearchParams(window.location.search).get("ReturnUrl");
        const result = await PostJSON("/users/sign_in_passwordless", { email, code: formData.code, returnUrl });
        if (result.ok) {
            window.location = result.returnUrl;
            return true;
        } else {
            throw new Error(result?.message);
        }
    } catch (err) {
        console.error(err);
        let message = err.message;
        // Override with more descriptive message
        if (message === "An invalid code was entered.") {
            message = "An invalid code was entered.\n\nCodes expire after 15 minutes, 3 incorrect tries, or upon requesting a new code.\n\nPlease recheck your code or check your email for a more recent code."
        }
        SubmitStatus.Set("code-status", message, true);
    }
}, "codesubmit");
